import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { AppSharedModule } from 'app/app-shared.module';
import { AiInsight } from '../../../../../../../providers/semantria-api/ai-insights.service';
import { AiInsightCardModel } from '../insight-card.component';

@Component({
  selector: 'app-insight-card-modal',
  standalone: true,
  imports: [AppSharedModule, TranslocoModule],
  templateUrl: './insight-card-modal.component.html',
  styleUrl: './insight-card-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class InsightCardModalComponent {
  // if this modal is reused in future, we need to make sure all required inputs are provided
  @Input({ required: true }) isVisible: boolean;
  @Input({ required: true }) canUpdateInsights: boolean;
  @Input({ required: true }) insight: AiInsight;
  @Input({ required: true }) insightCardModel: AiInsightCardModel;
  @Input({ required: true }) bodyTemplate: TemplateRef<any>;
  @Input() publishedAt: Date | null = null;
  @Input() publisherDisplayName = '';

  @Input() isImageLoading = false;
  @Input() imageExists = false;
  @Input() insightImage: string | ArrayBuffer | undefined;

  @Output() closed = new EventEmitter<void>();
  @Output() editClicked = new EventEmitter<void>();

  onClose() {
    this.closed.emit();
  }

  onEditClicked() {
    this.editClicked.emit();
  }
}
